// composables/useStockPolling.js
import { ref, onMounted, onUnmounted, watch } from 'vue'
import PosService from '@/service/PosService'

const posService = new PosService()

export function useStockPolling(carrito, sucursalId, options = {}) {
    const { interval = 5000, autoStart = true } = options
    
    const stockActualizadoProductos = ref({})
    const stockActualizadoPaquetes = ref({})
    const loading = ref(false)
    const error = ref(null)
    let intervalId = null

    const obtenerIds = () => {
        const productos_ids = carrito.value.filter(item => !item.es_paquete).map(item => item.id).filter(id => id)
        const paquetes_ids = carrito.value.filter(item => item.es_paquete).map(item => item.id).filter(id => id)
        return { productos_ids, paquetes_ids }
    }

    const actualizar = async () => {
        const { productos_ids, paquetes_ids } = obtenerIds()
        if (productos_ids.length === 0 && paquetes_ids.length === 0) {
            stockActualizadoProductos.value = {}
            stockActualizadoPaquetes.value = {}
            return
        }

        try {
            loading.value = true
            error.value = null
            
            const response = await posService.actualizarStock(productos_ids, paquetes_ids, sucursalId.value)
            
            if (response.success) {
                stockActualizadoProductos.value = response.data?.productos || {}
                stockActualizadoPaquetes.value = response.data?.paquetes || {}
            }
        } catch (err) {
            error.value = err.message
            console.error('Error en polling de stock:', err)
        } finally {
            loading.value = false
        }
    }

    const iniciar = () => {
        if (intervalId) return
        actualizar()
        intervalId = setInterval(actualizar, interval)
    }

    const detener = () => {
        if (intervalId) {
            clearInterval(intervalId)
            intervalId = null
        }
    }

    const obtenerStock = (id, es_paquete) => {
        if (es_paquete) {
            return stockActualizadoPaquetes.value[id]?.stock_actual ?? null
        }
        return stockActualizadoProductos.value[id]?.stock_actual ?? null
    }

    const estaDisponible = (id, es_paquete) => {
        const data = es_paquete ? stockActualizadoPaquetes.value[id] : stockActualizadoProductos.value[id]
        if (data === undefined) return true // Aún no actualizado
        return data.disponible
    }

    onMounted(() => {
        if (autoStart) iniciar()
    })

    onUnmounted(() => {
        detener()
    })

    // Reiniciar polling solo cuando cambie la sucursal (para no bombardear el servidor al modificar el carrito)
    watch(() => sucursalId.value, () => {
        if (autoStart) {
            detener()
            iniciar()
        }
    })

    return {
        stockActualizadoProductos,
        stockActualizadoPaquetes,
        loading,
        error,
        actualizar,
        iniciar,
        detener,
        obtenerStock,
        estaDisponible
    }
}